import React from "react";

const Paragraph: React.FC<{ children: string }> = ({ children }) => {
  return (
    <p className="legal-paragraph">
      {children}
    </p>
  );
}

export default Paragraph;